import {computed, ref} from 'vue'
import {defineStore} from 'pinia'
import axios from 'axios'

axios.defaults.baseURL = import.meta.env.VITE_APP_MIDDLEWARE

export const useStudyStore = defineStore('study', () => {
  const studies = ref([])
  function setStudies(payload) {
    if(!payload.order){
      studies.value = studies.value.concat(payload.studies); //concatenamos la información
    }else{
      let temp = studies.value.concat(payload.studies); //concatenamos la información
      temp.sort((a, b) => (a.title > b.title) ? -1 : 1);
      studies.value = temp;
    }
  }

  async function fetchStudies() {
    let result = [];
    let studiesTemp = [];
    try {
      const {data} = await axios.get('/leads/cl')

      result = data.filter(estudio => {
        return estudio.tipoEstudio === 'Undergraduate Studies' && estudio.idioma === 'Spanish' && estudio.anioAcademico  >= import.meta.env.VITE_APP_CURSO_ACADEMICO
      })

      setStudies({'studies': result, 'order': true})
      console.log('Petición realizada.');
    } catch (e) {
      setStudies({'studies': [], 'order': true});
      console.log('Petición realizada con fallos.' + e);
    }
  }

  const academicYears = computed( () => {
    //obtener los años académicos sin repetidos
    let years = studies.value.map(study => study.anioAcademico);
    return [...new Set(years)];

  })

  return { studies, academicYears, setStudies, fetchStudies }
})
